import * as types from '../mutation-types'
import axios from '@/api/operator-group.js'
export default {
  state: {
    member: {},    // 使用者資訊
    permission: {} // 操作員權限
  },
  actions: {
    setlogindata ({ commit, dispatch }, value) {
      commit(types.SET_USERNAME_DATA, value)
      dispatch('getOperatorGroupData', value.comtion)
    },
    getOperatorGroupData({ commit }, value) { // 存入操作員權限
      const arraykey = {
        'system': [0, 1, 2], 
        'member': [3, 4, 5, 6], 
        'operator': [7, 8, 9, 10], 
        'opergroup': [11, 12, 13, 14], 
        'period': [15, 16, 17, 18], 
        'lottery': [19, 20], 
        'inspect': [21, 22, ], 
        'immediate': [23 ], 
        'sup': [24, 25], 
        'report': [26], 
        'indata': [27, 28], 
        'currency': [29, 30, 31], 
        'gameies': [32, 33, 34],
        'gameset': [35, 36, 37, 38, 39, 40],
        'gameswitch': [41, 42, 43, 44],
        'settlement': [45, 46]
      }
      let data = {}
      for (let key in arraykey) {
        const val = arraykey[key]
        for (let i = 0; i < value.length; i++) {
          const it = value[i];
          const some = (number) => {
            return number.some(res => i == res)
          }
          if(some(val)) {
            key in data 
              ? data[key].push(it)
              : (data[key] = [], data[key].push(it))
          }
        }
      }
      commit(types.SETTING_USER_PERMISSION, data)
    }
  },
  mutations: {
    [types.SET_USERNAME_DATA] (state, value) {
      state.member = value
    },
    [types.SETTING_USER_PERMISSION] (state, value) {
      state.permission = value
    }
  },
  getters: {
    getmember: (state) => state.member,
    getpermission: (state) => state.permission
  }
}